import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/Layout';
import SeoDatoCMS from '../components/Layout/SeoDatocms';
import Blocks from '../components/Blocks';
import HeroBasic from '../components/Global/HeroBasic/HeroBasic';
import { isBlueColor } from '../utils';
import PageLoader from '../components/Blocks/PageLoader';

const Page = ({ pageContext, data: { page, config, favicon } }) => {
  const {
    seo,
    title,
    backgroundImage,
    backgroundImageMobile,
    backgroundImageAlignment,
    backgroundColorHero,
    blocks = [],
  } = page;

  return (
    <>
      <SeoDatoCMS seo={seo} favicon={favicon} />
      <PageLoader config={config} page={page} favicon={favicon} context={pageContext}>
        <Layout isBlueHeader={isBlueColor(backgroundColorHero)}>
          <HeroBasic
            title={title}
            image={backgroundImage}
            imageMobile={backgroundImageMobile}
            imageAlignment={backgroundImageAlignment}
            backgroundColor={backgroundColorHero}
          />

          <div className="inner-page">
            <Blocks blocks={blocks} />
          </div>
        </Layout>
      </PageLoader>
    </>
  );
};

export default Page;

export const PageQuery = graphql`
  query PageById($id: String) {
    favicon: datoCmsSite {
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }
    config: datoCmsSiteConfiguration {
      maintenanceMode
    }
    page: datoCmsBasicPage(id: { eq: $id }) {
      title
      id
      protectedPage
      backgroundImage {
        url
        gatsbyImageData
      }
      backgroundImageMobile {
        url
        gatsbyImageData
      }
      backgroundImageAlignment
      backgroundColorHero {
        ... on DatoCmsColor {
          color {
            hex
          }
          textContrast
        }
      }
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      blocks {
        ... on DatoCmsNarrativeBlock {
          ...BlockNarrativeBlock
        }
        ... on DatoCmsCountdown {
          ...BlockCountdown
        }
        ... on DatoCmsAcordion {
          ...BlockAccordion
        }
        ... on DatoCmsEveryactionBlock {
          ...BlockEveryaction
        }
        ... on DatoCmsDonation {
          ...BlockDonation
        }
        ... on DatoCmsLogo {
          ...BlockLogos
        }
        ... on DatoCmsBoxLink {
          ...BlockBoxLInk
        }
        ... on DatoCmsPeoplePowerLink {
          ...BlockPeoplePower
        }
        ... on DatoCmsFormBlock {
          ...BlockForm
        }
        ... on DatoCmsUserStoriesBlock {
          ...BlockUserStories
        }
        ... on DatoCmsFollowUsSocial {
          ...BlockFollowUs
        }
        ... on DatoCmsGroupPerson {
          ...BlockGroupPerson
        }
        ... on DatoCmsTimeline {
          ...BlockTimeline
        }
        ... on DatoCmsDistributor {
          ...BlockDistributor
        }
        ... on DatoCmsText {
          ...BlockText
        }
        ... on DatoCmsVideoBlock {
          ...BlockVideo
        }
        ... on DatoCmsFullWidthEveryactionBlock {
          ...BlockFullWidthEveryaction
        }
        ... on DatoCmsHeading {
          ...BlockHeading
        }
      }
    }
  }
`;
